// extracted by mini-css-extract-plugin
module.exports = {"ctf":"ctf-rich-text_ctf__QV60q","font":"ctf-rich-text_font__lfS_o","margins":"ctf-rich-text_margins__ROmhr"};